import React from 'react';

import { CurrencyInput } from '@eika/currency-input';

import { toCalculatorFieldNameOrUndefined, toNumberOrUndefined } from '../functions/type-functions';
import { CalculatorFieldName, Piwik } from '../types';

interface CalculatorAmountInputProps {
    id: string;
    name: string;
    value: number | undefined;
    onChangeAmount: (amount: number | undefined) => void;
    onChangeFocus: (calculatorFieldName: CalculatorFieldName | undefined) => void;
    piwik: Piwik | undefined;
}

const CalculatorAmountInput = ({ onChangeAmount, onChangeFocus, piwik, ...rest }: CalculatorAmountInputProps) => (
    <CurrencyInput
        {...rest}
        className="select-amount"
        onValueChange={({ floatValue }) => {
            onChangeAmount(toNumberOrUndefined(floatValue));
        }}
        onFocus={({ target }) => {
            onChangeFocus(toCalculatorFieldNameOrUndefined(target.id));
        }}
        thousandSeparator={false}
        decimalScale={4}
        suffix=""
        autoComplete="off"
        data-track-id={piwik?.visaCalculator?.visaExchangeCalculatorAmountInput?.dataTrackId}
        data-track-linkname={piwik?.visaCalculator?.visaExchangeCalculatorAmountInput?.dataTrackLinkname}
    />
);

export default CalculatorAmountInput;
